// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22UvX","colMin":"styles_colMin__3r_Mb"};